<!--
  --
  -- Input コンポーネント
  --
  -->
<template>
  <div class="c-input">
    <div class="caption" :class="labelColor">{{label}}</div>

    <v-input
      class="mt-n1"
      :value="value"
      :rules="rules"
      @change="$emit('change', $event)"
      @focusin.native="onFocus"
      @focusout.native="onFocus"
    >
      <slot/>
    </v-input>
  </div>
</template>

<script>
export default {
  name: 'CInput',

  // v-model
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    // 値
    value: {},

    // ラベル
    label: {
      type: String
    },

    // ルール
    rules: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    // フォーカスされているか
    focused: false
  }),
  computed: {
    /**
     * ラベル色を返す
     */
    labelColor () {
      return this.focused ? 'primary--text' : ''
    }
  },
  methods: {
    /**
     * 子要素のフォーカスの状態を取得する
     */
    onFocus (event) {
      this.focused = (event.type === 'focusin')
    }
  }
}
</script>
